import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import React from 'react'
import {OldRegistrationButton} from './old'
import {RegistrationButtonProps} from './old/interfaces'
import {RegistrationButton as NewRegistrationButton} from './registration-button'

export const RegistrationButton: React.FC<RegistrationButtonProps> = props => {
  const {experiments} = useExperiments()

  return experiments.enabled(ExperimentNames.RegistrationStatusInfo) ? (
    <NewRegistrationButton {...props} />
  ) : (
    <OldRegistrationButton {...props} />
  )
}
